import { v4 as uuidv4 } from 'uuid';
import type { IdentityProfile, IdentityProfileApi } from '../types';

export const normalizeUserData = (profileData: IdentityProfileApi): IdentityProfile | undefined => {
  if (!profileData) {
    return undefined;
  }
  return {
    ...profileData,
    id: Number(profileData.sub),
    userType: profileData.UserType,
    applicationID: Number(profileData.ApplicationID),
    lastName: profileData.LastName,
    firstName: profileData.name,
    userGuid: uuidv4(),
  };
};
